export default __webpack_public_path__ + "static/media/banner.5d8d3017.png";